import React from 'react';
import { NavLink, Outlet, Route, Routes } from 'react-router-dom';

import AllDiscrepancies from './AllDiscrepancies';
import AllInvoices from './AllInvoices';
import CreateInvoices from './CreateInvoices';


export default function Billing(props) {
    return (
        <Routes>
            <Route path="/*" element={<Layout />}>
                <Route index element={<View view="createinvoices" />}/>
                <Route path="createinvoices" element={<View view="createinvoices" />} />
                <Route path="allinvoices" element={<View view="allinvoices" />} />
                <Route path="alldiscrepancies" element={<View view="alldiscrepancies" />} />
            </Route>
        </Routes>
    )
}

function Layout(props) {
    return (
        <>
        <section>
            <h3>Billing</h3>
        </section>
        <div className='grid-container'>
            <nav >
                <ul className="nav">
                     <li>
                        <NavLink to="createinvoices" end className={({ isActive }) =>
                            isActive ? 'active' : undefined
                        }>Create invoices</NavLink>
                    </li>
                    <li>
                        <NavLink to="allinvoices" className={({ isActive }) =>
                            isActive ? 'active' : undefined
                        }>All invoices</NavLink>
                    </li>
                    <li>
                        <NavLink to="alldiscrepancies" className={({ isActive }) =>
                            isActive ? 'active' : undefined
                        }>All discrepancies</NavLink>
                    </li>
                </ul>
            </nav>
            
        </div>
        <div>
                <Outlet />
            </div>
        </>
    )
}

function View(props) {
    const { view } = props;
    switch (view) {
        case 'allinvoices':
            return (<React.Suspense fallback={<p>Loading...</p>}><section><AllInvoices /></section></React.Suspense>);
        case 'createinvoices':
            return (<React.Suspense fallback={<p>Loading...</p>}><section><CreateInvoices /></section></React.Suspense>);
        case 'alldiscrepancies':
            return (<React.Suspense fallback={<p>Loading...</p>}><section><AllDiscrepancies /></section></React.Suspense>);
        default:
            return <p>Not found</p>;
    }
}